import React from 'react';
import './Shop.css';

export const Shop = () => {
  return (
    <div className="right__sidebar">
      <p className="title">Shop</p>
      <ul>
        <li>Drones</li>
        <li>Sci-Fi</li>
        <li>Toys</li>
        <li>Characters</li>
        <li>View all</li>
      </ul>
    </div>
  );
};
